import { List, Record } from 'immutable';
export default Record({
  field: '',
  values: List()
}, 'SearchFilterRecord');